import { render, staticRenderFns } from "./ColumnsFilter.vue?vue&type=template&id=0173d13e&"
import script from "./ColumnsFilter.vue?vue&type=script&lang=ts&"
export * from "./ColumnsFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports